/* RevitalGlow custom cart drawer.
   Watches cart requests (theme, Kaching, anything else) and repaints from the
   rg-cart section. Optimistic updates, no polling, no price scraping.

   Three behaviours beyond plain drawer mechanics, all driven by markup rather
   than by scraping prices:

   1. FREE GIFT  - snippets/rg-cart-contents.liquid works out in Liquid whether
      the gift has been earned and whether it is already in the cart, and
      prints both answers on [data-rg-rewards-data]. reconcileGift() just makes
      the cart agree with that. All the threshold logic lives in the Liquid.

   2. PLAN SWITCH - a subscription line that reaches 3 units moves from the
      monthly plan to the 3-monthly one (and back down again below 3), so
      someone who adds bottles with the + button lands on the same schedule as
      the Buy 2 Get 1 Free offer instead of being billed monthly for three.

   3. COALESCED STEPPER - presses on - and + are collected and sent as one
      request once the customer stops pressing. See the "stepper" section for
      why, and for what this replaced. */
(function () {
  if (window.__rgCartInit) return;
  window.__rgCartInit = true;

  var SECTION = 'rg-cart';
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
  var ADD_RE = /\/cart\/add/i;

  /* Subscription plans, paired monthly -> 3-monthly. There is one pair per
     market because the subscription app keeps separate plan groups for UK and
     US; Shopify picks the right one, this map only has to know both.
     Names as they appear in the cart: "Deliver Every Month" / "Deliver Every
     3 Months". If a plan is ever rebuilt in the app these ids change. */
  var PLAN_PAIRS = [
    { monthly: '5815894231', quarterly: '5815926999' }, /* UK  - 30 / 90 Day Supply */
    { monthly: '7208796375', quarterly: '7208829143' }  /* US  - 30 / 90 Day Supply */
  ];
  var BUNDLE_QTY = 3;

  /* Give up after this many failed gift add/remove attempts rather than
     hammering the cart, and never leave the prices masked longer than this. */
  var GIFT_MAX_ATTEMPTS = 3;
  var SETTLE_TIMEOUT = 4000;

  /* How long to wait for the customer to stop pressing - + before sending.
     Long enough to catch a double tap, short enough that a single press still
     feels immediate. The press itself shows on screen straight away, so this
     delay is never visible; it only decides when the request leaves. */
  var STEPPER_DEBOUNCE = 350;

  var root, body, countEl, totalEl, protectionEl;
  var lastFocused = null;
  var busy = false;
  var paintSeq = 0; /* only the newest response may paint */
  var pendingOpen = false; /* open the drawer once fresh contents are painted */
  var pendingTimer = null;
  var settleTimer = null;
  var giftBusy = false;
  var giftAttempts = 0; /* stops a failing add/remove retrying on every paint */

  /* Quantities the customer has asked for but which have not been sent yet,
     keyed by cart line key. Created with a null prototype so a line key can
     never collide with something inherited from Object.prototype. */
  var pending = Object.create(null);
  var flushTimer = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function hasPending() {
    for (var k in pending) return true;
    return false;
  }

  function cache() {
    root = document.getElementById('rg-cart');
    if (!root) return false;
    body = $('[data-rg-body]', root);
    countEl = $('[data-rg-count]', root);
    totalEl = $('[data-rg-checkout-total]', root);
    protectionEl = $('[data-rg-protection]', root);
    return true;
  }

  /* Empty cart shows the header and message only: no progress bar, no footer */
  function setEmpty(isEmpty) {
    if (root) root.classList.toggle('rg-cart--empty', !!isEmpty);
  }

  /* ---------- open / close ---------- */

  function open() {
    if (!root || root.classList.contains('rg-cart--open')) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('rg-cart--open'); });
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.rg-cart__close', root);
    if (closeBtn) closeBtn.focus();
    document.dispatchEvent(new CustomEvent('rg-cart:open'));
  }

  function close() {
    if (!root) return;
    root.classList.remove('rg-cart--open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    document.dispatchEvent(new CustomEvent('rg-cart:close'));
  }

  /* After an add: paint the new contents first, then open, so the drawer never
     flashes the old (empty) cart. Opens anyway if the store is slow to answer. */
  function openFresh() {
    if (!root) return;
    if (root.classList.contains('rg-cart--open')) { refresh(); return; }
    pendingOpen = true;
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(function () {
      if (!pendingOpen) return;
      pendingOpen = false;
      if (body && !body.querySelector('.rg-item')) body.innerHTML = '<div class="rg-cart__empty">Updating your cart&hellip;</div>';
      open();
    }, 1500);
    refresh();
  }

  /* ---------- painting ---------- */

  function syncThemeCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .site-header__cart-count');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    for (var j = 0; j < bubbles.length; j++) {
      bubbles[j].classList.toggle('cart-link__bubble--visible', count > 0);
    }
  }

  function paint(html, seq) {
    if (seq !== undefined && seq !== paintSeq) return; /* stale response */
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var data = doc.getElementById('rg-cart-data');
    if (!data || !body) return;

    body.innerHTML = data.innerHTML;

    var count = parseInt(data.getAttribute('data-count'), 10) || 0;
    var protectionOn = data.getAttribute('data-protection') === 'true';

    if (countEl) countEl.textContent = count;
    if (totalEl) totalEl.textContent = data.getAttribute('data-total') || '';
    if (protectionEl) {
      protectionEl.checked = protectionOn;
      protectionEl.disabled = false;
    }

    var checkout = $('[data-rg-checkout]', root);
    if (checkout) checkout.disabled = count === 0;
    setEmpty(count === 0);
    syncThemeCount(count);

    if (pendingOpen) {
      pendingOpen = false;
      window.clearTimeout(pendingTimer);
      open();
    }

    /* never leave protection alone in the cart */
    if (count === 0 && protectionOn) setProtection(false);

    /* This markup carries the server's quantities, which are behind anything
       the customer has pressed but which has not been sent yet. Put their
       intent back, or the stepper flicks to an older number and forward again. */
    reapplyPending();

    /* Worked out BEFORE reconcileGift(), because that call is what increments
       giftAttempts and would otherwise change the answer under us. */
    setSettling(giftAttempts < GIFT_MAX_ATTEMPTS ? giftPlan(body) : null);

    reconcileGift();
  }

  function refresh() {
    if (!root) return Promise.resolve();
    var seq = ++paintSeq;
    var url = '/?sections=' + SECTION + '&_=' + Date.now();
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (json) { paint(json[SECTION] || '', seq); })
      .catch(function () {});
  }

  /* ---------- cart writes ---------- */

  function postCart(path, payload, seq) {
    return fetch(path + '?rg=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.sections && json.sections[SECTION]) paint(json.sections[SECTION], seq);
        else return refresh();
      })
      .catch(function () { return refresh(); });
  }

  /* ---------- free gift ----------
     The Liquid has already decided; this only closes the gap between what the
     rewards bar says should be true and what is actually in the cart. */

  /* What the Liquid says still needs doing to the cart, or null when the cart
     already agrees with it. scope is the live drawer body. */
  function giftPlan(scope) {
    var data = scope && scope.querySelector('[data-rg-rewards-data]');
    if (!data) return null;

    var variantId = data.getAttribute('data-gift-variant');
    if (!variantId || variantId === '0') return null;

    var earned = data.getAttribute('data-gift-earned') === 'true';
    var inCart = data.getAttribute('data-gift-in-cart') === 'true';
    if (earned === inCart) return null;

    return { variantId: variantId, add: earned };
  }

  /* SETTLING (looks odd until you know why)
     Adding or removing the gift is a SECOND round trip, so the cart being
     painted right now is the state BEFORE it, and the two states disagree
     about money. With no gift line present the BXGY gift discount has nothing
     to attach to, so Kaching's bundle discount applies and the 3-bottle line
     reads 79.89 with a 1.11 saving; the moment the gift lands the BXGY takes
     over, displaces Kaching, and the same line reads 81.00 with no saving.
     Painting the first set and correcting it a second later flashed a price
     and a saving that were about to vanish - measured at 983ms on 28 Sep 2026
     and reported by the owner as "the old price and the small saving".

     So the money is masked for that moment instead of being shown and then
     corrected. Everything else - titles, images, stepper, rewards bar - paints
     straight away, so the drawer still feels immediate.

     When the gift is on its way OUT, the gift row is hidden too: leaving a row
     that says YOUR FREE GIFT above a bar that already says "add 1 more bottle"
     is the same lie in the other direction.

     The timer is a dead man's switch. If the reconcile never comes back the
     prices must not stay hidden for ever. */
  function setSettling(plan) {
    if (!root) return;
    root.classList.toggle('rg-cart--settling', !!plan);
    root.classList.toggle('rg-cart--settling-out', !!plan && !plan.add);
    window.clearTimeout(settleTimer);
    if (plan) {
      settleTimer = window.setTimeout(function () {
        root.classList.remove('rg-cart--settling');
        root.classList.remove('rg-cart--settling-out');
      }, SETTLE_TIMEOUT);
    }
  }

  function reconcileGift() {
    if (giftBusy || !body) return;

    var plan = giftPlan(body);
    if (!plan) { giftAttempts = 0; return; }
    if (giftAttempts >= GIFT_MAX_ATTEMPTS) return; /* something is wrong; stop hammering the cart */

    giftBusy = true;
    giftAttempts++;
    var seq = ++paintSeq;
    var done = function () {
      giftBusy = false;
      if (hasPending()) scheduleFlush(); /* a press waited for this to finish */
    };

    if (plan.add) {
      postCart('/cart/add.js', { items: [{ id: parseInt(plan.variantId, 10), quantity: 1 }], sections: SECTION }, seq).then(done);
    } else {
      postCart('/cart/change.js', { id: String(plan.variantId), quantity: 0, sections: SECTION }, seq).then(done);
    }
  }

  /* ---------- subscription plan switch ---------- */

  /* Returns the plan this line should move to, or null to leave it alone.
     A line with no plan (one-time purchase) is never touched. */
  function planFor(currentPlanId, quantity) {
    if (!currentPlanId || quantity < 1) return null;
    for (var i = 0; i < PLAN_PAIRS.length; i++) {
      var pair = PLAN_PAIRS[i];
      if (currentPlanId === pair.monthly && quantity >= BUNDLE_QTY) return pair.quarterly;
      if (currentPlanId === pair.quarterly && quantity < BUNDLE_QTY) return pair.monthly;
    }
    return null;
  }

  /* ---------- stepper ----------
     WHY THIS IS A QUEUE AND NOT A DIRECT CALL (the bug it replaced)

     This used to be one function that opened with `if (busy) return;` - a press
     arriving while a previous cart write was in flight was silently thrown
     away. Not queued, not retried, and discarded BEFORE the on-screen number
     was updated, so nothing at all happened and the customer got no hint why.

     A cart round trip on this store runs 1.2-1.5s, and stepping down from 3
     fires two writes back to back (the quantity change, then removing the
     gift), so the dead window was well over a second. Measured 28 Sep 2026:
     a second press at 200 / 500 / 900 / 1200ms was lost every time; at 1500ms
     it worked. The owner hit it stepping 3 -> 2 -> 1 and read it as the rewards
     bar sticking, but the cart, the stepper and the bar were all still at 2 in
     agreement - the press simply never happened.

     It mattered most on +: someone tapping + twice to reach 3 landed on 2,
     missed the free-gift threshold, and was told to add a bottle they were
     certain they had already added.

     So presses are now collected instead of raced:
       queueLine()     shows the new number at once and records the target
       scheduleFlush() waits STEPPER_DEBOUNCE for the pressing to stop
       flush()         defers (never drops) while a write is in flight
       sendLine()      sends ONE request carrying the final number

     Two things fall out of it for free: a burst of N presses costs one request
     instead of N, and planFor() is evaluated once against the number the
     customer settled on rather than against every value they passed through. */

  /* Find the row a queued change belongs to.
     The cart line key is "<variantId>:<hash of the line's properties>", so
     switching the selling plan gives the same product a NEW key. If a repaint
     landed while the customer was still pressing, the key captured at the first
     press is already dead and Shopify would reject it - hence the fallback to
     whichever row currently holds the same variant, the part of the key that
     does not change. */
  function resolveRow(key) {
    if (!body) return null;
    var row = body.querySelector('[data-rg-line="' + key + '"]');
    if (row) return row;
    return body.querySelector('[data-rg-line^="' + String(key).split(':')[0] + ':"]');
  }

  function optimistic(row, quantity) {
    if (!row) return;
    if (quantity === 0) {
      row.remove();
      if (!body.querySelector('.rg-item')) {
        var msg = (window.theme && theme.strings && theme.strings.cartEmpty) || 'Your cart is currently empty.';
        body.innerHTML = '<div class="rg-cart__empty">' + msg + '</div>';
        setEmpty(true);
      }
    } else {
      var input = $('[data-rg-input]', row);
      if (input) input.value = quantity;
    }
  }

  /* A repaint overwrites the stepper with the server's number. Anything the
     customer has pressed since is still only in `pending`, so put it back. */
  function reapplyPending() {
    for (var key in pending) {
      var row = resolveRow(key);
      if (!row) continue;
      var input = $('[data-rg-input]', row);
      if (input) input.value = pending[key];
    }
  }

  /* The only entry point for changing a line. Never sends immediately.
     The remove button and the typed quantity box go through here too, so there
     is exactly one path to reason about; the row disappears or the number
     changes on the spot either way, so the wait is not perceptible. */
  function queueLine(key, quantity, row) {
    if (!key) return;
    optimistic(row, quantity);
    pending[key] = quantity;
    scheduleFlush();
  }

  function scheduleFlush() {
    window.clearTimeout(flushTimer);
    flushTimer = window.setTimeout(flush, STEPPER_DEBOUNCE);
  }

  function flush() {
    if (!hasPending()) return;

    /* Wait, do not drop. Sending now would race a write already in flight and
       could use a line key that write is about to invalidate. */
    if (busy || giftBusy) { scheduleFlush(); return; }

    for (var key in pending) {
      var quantity = pending[key];
      delete pending[key];
      sendLine(key, quantity);
      return; /* one line per flush; sendLine re-arms if more are waiting */
    }
  }

  function sendLine(key, quantity) {
    var row = resolveRow(key);

    /* Removing a line optimistically takes its row out of the DOM, so there is
       nothing left to resolve - that case still has to send. A row that cannot
       be found for any other quantity means the line is genuinely gone. */
    if (!row && quantity > 0) return;

    var payload = {
      id: row ? row.getAttribute('data-rg-line') : key,
      quantity: quantity,
      sections: SECTION
    };
    var nextPlan = planFor(row && row.getAttribute('data-rg-plan'), quantity);
    if (nextPlan) payload.selling_plan = parseInt(nextPlan, 10);

    busy = true;
    var seq = ++paintSeq;
    postCart('/cart/change.js', payload, seq).then(function () {
      busy = false;
      if (hasPending()) scheduleFlush();
    });
  }

  /* Package Protection toggle: adds or removes the protection product.
     /cart/change.js only accepts the id as a string (a number is rejected with 400). */
  function setProtection(on) {
    if (!protectionEl) return;
    var variantId = protectionEl.getAttribute('data-rg-variant');
    if (!variantId) return;
    protectionEl.disabled = true;
    var seq = ++paintSeq;
    var done = function () { protectionEl.disabled = false; };
    if (on) {
      postCart('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: SECTION }, seq).then(done);
    } else {
      postCart('/cart/change.js', { id: String(variantId), quantity: 0, sections: SECTION }, seq).then(done);
    }
  }

  function rowOf(el) { return el.closest('.rg-item'); }
  function lineKeyOf(el) { var r = rowOf(el); return r ? r.getAttribute('data-rg-line') : null; }
  function qtyOf(el) {
    var r = rowOf(el);
    var input = r ? $('[data-rg-input]', r) : null;
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  /* ---------- events ---------- */

  function bind() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-rg-close]')) { e.preventDefault(); close(); return; }
      if (t.closest('[data-rg-checkout]')) { e.preventDefault(); window.location.href = '/checkout'; return; }

      /* qtyOf() reads the box, which queueLine() has already updated, so a run
         of presses counts up or down from the number actually on screen. */
      var minus = t.closest('[data-rg-minus]');
      if (minus) { e.preventDefault(); queueLine(lineKeyOf(minus), Math.max(0, qtyOf(minus) - 1), rowOf(minus)); return; }

      var plus = t.closest('[data-rg-plus]');
      if (plus) { e.preventDefault(); queueLine(lineKeyOf(plus), qtyOf(plus) + 1, rowOf(plus)); return; }

      var remove = t.closest('[data-rg-remove]');
      if (remove) { e.preventDefault(); queueLine(lineKeyOf(remove), 0, rowOf(remove)); return; }

      var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], .js-drawer-open-cart, [data-rg-open]');
      if (cartLink && !t.closest('#rg-cart')) {
        e.preventDefault();
        e.stopPropagation();
        open();
        refresh();
      }
    }, true);

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.matches('[data-rg-protection]')) { setProtection(target.checked); return; }

      var input = target.closest('[data-rg-input]');
      if (input) queueLine(lineKeyOf(input), Math.max(0, parseInt(input.value, 10) || 0), rowOf(input));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) close();
    });
  }

  /* ---------- watch cart mutations from any source ---------- */

  function watchRequests() {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mine = url.indexOf('rg=1') !== -1;
        var isMutation = !mine && MUTATION_RE.test(url);
        var isAdd = isMutation && ADD_RE.test(url);
        return origFetch.apply(this, arguments).then(function (res) {
          if (isMutation) {
            if (isAdd) openFresh();
            else refresh();
          }
          return res;
        });
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__rgUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__rgUrl || '';
      if (url.indexOf('rg=1') === -1 && MUTATION_RE.test(url)) {
        xhr.addEventListener('load', function () {
          if (ADD_RE.test(url)) openFresh();
          else refresh();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function init() {
    if (!cache()) return;
    bind();
    watchRequests();
    var count = parseInt(countEl && countEl.textContent, 10) || 0;
    var checkout = $('[data-rg-checkout]', root);
    if (checkout) checkout.disabled = count === 0;
    setEmpty(count === 0);
    /* the drawer is server-rendered, so paint() has not run yet */
    setSettling(giftPlan(body));
    reconcileGift();
    window.rgCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();